<template>
    <div class="ro-filterbar">
        <el-input
            v-model="local.keyword"
            placeholder="Tìm theo tiêu đề, mô tả..."
            prefix-icon="el-icon-search"
            size="small"
            clearable
            class="ro-filterbar__keyword"
            @input="emitDebounced"
            @clear="emitChange"
        />
        <el-select
            v-model="local.type"
            placeholder="Loại tuyển dụng"
            size="small"
            clearable
            class="ro-filterbar__field"
            @change="emitChange"
        >
            <el-option v-for="opt in orderTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
        </el-select>
        <el-select
            v-model="local.status"
            placeholder="Trạng thái"
            size="small"
            clearable
            class="ro-filterbar__field"
            @change="emitChange"
        >
            <el-option v-for="opt in statusOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
        </el-select>
        <el-select
            v-if="showDepartmentFilter"
            v-model="local.department_id"
            placeholder="Phòng ban"
            size="small"
            clearable
            filterable
            class="ro-filterbar__field"
            @change="emitChange"
        >
            <el-option v-for="d in departments" :key="d.id" :label="d.name" :value="d.id" />
        </el-select>
        <el-button size="small" icon="el-icon-refresh" circle @click="reset" title="Xoá bộ lọc" />
    </div>
</template>

<script>
import { ORDER_STATUS_OPTIONS, ORDER_TYPE_OPTIONS } from "@/core/config/recruitmentOrders/recruitmentOrdersOption";

const BLANK_FILTERS = { status: "", type: "", department_id: "", keyword: "" };

export default {
    name: "OrderFilterBar",
    props: {
        value: { type: Object, default: () => ({ ...BLANK_FILTERS }) },
        departments: { type: Array, default: () => [] },
        showDepartmentFilter: { type: Boolean, default: false },
    },
    data() {
        return {
            local: { ...BLANK_FILTERS, ...this.value },
            statusOptions: ORDER_STATUS_OPTIONS,
            orderTypeOptions: ORDER_TYPE_OPTIONS,
            debounceTimer: null,
        };
    },
    watch: {
        value: {
            deep: true,
            handler(v) {
                this.local = { ...BLANK_FILTERS, ...v };
            },
        },
    },
    beforeDestroy() {
        clearTimeout(this.debounceTimer);
    },
    methods: {
        emitChange() {
            this.$emit("input", { ...this.local, order_type: this.local.type });
            this.$emit("change", { ...this.local, order_type: this.local.type });
        },
        emitDebounced() {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(this.emitChange, 350);
        },
        reset() {
            this.local = { ...BLANK_FILTERS };
            this.emitChange();
        },
    },
};
</script>

<style scoped>
.ro-filterbar {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
}
.ro-filterbar__keyword {
    flex: 1 1 240px;
    min-width: 220px;
    max-width: 340px;
}
.ro-filterbar__field {
    flex: 0 1 185px;
    min-width: 160px;
}
.ro-filterbar /deep/ .el-input__inner {
    border-radius: 8px;
    border-color: #e2e8f0;
}
.ro-filterbar /deep/ .el-input__inner:focus {
    border-color: #4f46e5;
}
.ro-filterbar /deep/ .el-button--default {
    border-radius: 8px;
    border-color: #e2e8f0;
    color: #64748b;
}
.ro-filterbar /deep/ .el-button--default:hover {
    color: #4f46e5;
    border-color: #c7d2fe;
    background-color: #eef2ff;
}
</style>
